import { logoStyles } from "@insite/content-library/Widgets/Basic/Logo";
import { addToCartButtonStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsAddToCartButton";
import { quantityOrderedStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsQuantityOrdered";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

Object.assign(addToCartButtonStyles, {
    ...addToCartButtonStyles,
    button: {
        css: css`
            width: 100%;
            padding: 0.6rem 3rem;
            :hover {
                background-color: ${getColor("danger")};
                border-color: ${getColor("danger")};
            }
        `,
        typographyProps: {
            fontFamily: "NeuronBold",
            lineHeight: "17px",
            size: "18px",
        },
    },
});
